import type { GeneralAddress } from 'src/types/componentsQuasar';

export function getAddress(address: GeneralAddress) {
  return `https://www.google.com/maps/search/${address?.number ?? ''} ${address?.street ?? ''} St, ${address?.city ?? ''}, ${address?.zip ?? ''}, ${address?.country ?? ''}`;
}
